export default [
    {
        path: '/schedule-new',
        name: 'schedule-new',
        component: () => import ('../schedule/views/Index.vue'),
        meta: {
            title: 'Horário das aulas',
            icon: 'mdi-timeline-clock-outline',
            breadcrumbs: [
                { text: 'Horário', disabled: true, href: '/' },
                { text: 'Horário das aulas', disabled: true, href: '/' },
            ],
        }
    }
]
